import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { MealStatus } from '../enums/MealStatus'
import type { CompaniesEntity } from '@/features/companies/domain/entities/CompaniesEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class MealFilterEntity {
  id?: string
  service?: ServiceMiniEntity
  company?: CompaniesEntity
  branch?: BranchMiniEntity
  user?: UserMiniEntity
  statuses?: Array<MealStatus>
  fromDate?: string
  toDate?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
